export enum ActionRequiredBy {
  COMPANY = 'COMPANY',
  SUPPLIER = 'SUPPLIER'
}
